import React from 'react';
import PropTypes from 'prop-types';
import { RESCORING_INSTRUCTION } from '../../../../../../../constants/reading/TroConstants';
import './RescoringInstruction.scss';
import { generateReactKey } from '../../../../../../../utils/shared/commonUtils';

const RescoringInstruction = ({ instructionType }) => {
    const title = RESCORING_INSTRUCTION[instructionType].TITLE;
    const instructionItems = RESCORING_INSTRUCTION[instructionType].ITEMS;
    return (
        <div className="rescoring-instruction">
            <h5 className="title">{RESCORING_INSTRUCTION[instructionType].TITLE}</h5>
            <ol>
                {instructionItems.map((item, index) => (
                    <li key={generateReactKey(index, title)}>{item}</li>
                ))}
            </ol>
        </div>
    );
};

RescoringInstruction.defaultProps = {
    instructionType: '',
};

RescoringInstruction.propTypes = {
    instructionType: PropTypes.string,
};

export default RescoringInstruction;
